export const environment = {
  production: false,

  //Paths
  pathBackEnd: "https://pos.elfogonchicken.com/Fogon.Backend/public/",
  // pathBackEnd: "https://qas.elfogonchicken.com/Fogon.Backend/controllers/",
  pathPrinter: "http://localhost/TradeTech/fogon/Fogon.Printer/public/",
  pathApisPeruReniec: "https://dniruc.apisperu.com/api/v1/",

  //Tokens
  tokenApisPeruReniec: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6Im1jcnV6YWRvLjE5MTJAZ21haWwuY29tIn0.OmoG13zsXq-piAuhGAW_s9XI5Mp3ORSgk-SjpI1Tsfc",

  //Features
  // Auto-refresh silencioso de mesas en la pantalla Local (location).
  // Deshabilitado temporalmente por performance. Poner enabled=true para
  // rehabilitarlo; intervalMs controla la cadencia del polling.
  deskAutoRefresh: { enabled: false, intervalMs: 120000 },

  // Rehabilitar mozo dado de baja (mantenimiento de mozos). El boton
  // "Habilitar" no renderiza salvo que enabled=true. OFF por defecto.
  waiterReactivation: { enabled: false }
};
